console.log("Sticky ATC loaded");

(function () {
  function isProductPage() {
    return document.body.classList.contains("template-product");
  }

  function isMobile() {
    return window.matchMedia("(max-width: 999px)").matches;
  }

  function getOriginalATC() {
    return document.querySelector(
      'button[data-action="add-to-cart"].product-form__add-button'
    );
  }

  function ensureBar() {
    var bar = document.getElementById("StickyNativeATC");
    if (bar) return bar;

    bar = document.createElement("div");
    bar.id = "StickyNativeATC";
    bar.setAttribute("aria-hidden", "true");

    document.body.appendChild(bar);

    bar.style.setProperty("position", "fixed", "important");
    bar.style.setProperty("left", "0", "important");
    bar.style.setProperty("right", "0", "important");
    bar.style.setProperty("bottom", "0", "important");
    bar.style.setProperty("z-index", "999999", "important");
    bar.style.setProperty("padding", "10px 12px", "important");
    bar.style.setProperty("background", "rgba(255,255,255,0.98)", "important");
    bar.style.setProperty("border-top", "1px solid rgba(0,0,0,0.08)", "important");
    bar.style.setProperty("box-shadow", "0 -6px 18px rgba(0,0,0,0.06)", "important");
    bar.style.setProperty("transform", "translateY(110%)", "important");
    bar.style.setProperty("opacity", "0", "important");
    bar.style.setProperty("pointer-events", "none", "important");
    bar.style.setProperty("transition", "transform .25s ease, opacity .25s ease", "important");

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "button button--primary";
    btn.textContent = "Adaugă în coș";

    btn.style.setProperty("width", "100%", "important");
    btn.style.setProperty("line-height", "48px", "important");
    btn.style.setProperty("margin", "0", "important");
    btn.style.setProperty("border-radius", "10px", "important");

    btn.addEventListener("click", function () {
      var original = getOriginalATC();
      if (original && !original.disabled && original.getAttribute("aria-disabled") !== "true") {
        original.click();
      }
    });

    bar.appendChild(btn);
    return bar;
  }

  function syncButtonState(bar) {
    var original = getOriginalATC();
    var stickyBtn = bar.querySelector("button");
    if (!stickyBtn) return;

    if (!original) {
      stickyBtn.disabled = true;
      return;
    }

    stickyBtn.disabled =
      original.disabled || original.getAttribute("aria-disabled") === "true";

    var label = (original.textContent || "").trim();
    if (label) stickyBtn.textContent = label;
  }

  function show(bar) {
    bar.style.setProperty("transform", "translateY(0)", "important");
    bar.style.setProperty("opacity", "1", "important");
    bar.style.setProperty("pointer-events", "auto", "important");
    bar.setAttribute("aria-hidden", "false");
  }

  function hide(bar) {
    bar.style.setProperty("transform", "translateY(110%)", "important");
    bar.style.setProperty("opacity", "0", "important");
    bar.style.setProperty("pointer-events", "none", "important");
    bar.setAttribute("aria-hidden", "true");
  }

  function toggle(bar) {
    if (!isMobile()) {
      hide(bar);
      return;
    }

    if (document.body.classList.contains("no-mobile-scroll")) {
      hide(bar);
      return;
    }

    if (window.scrollY > 180) {
      show(bar);
    } else {
      hide(bar);
    }

    syncButtonState(bar);
  }

  function init() {
    if (!isProductPage()) return;

    var bar = ensureBar();
    toggle(bar);

    window.addEventListener("scroll", function () {
      toggle(bar);
    }, { passive: true });

    window.addEventListener("resize", function () {
      toggle(bar);
    });

    document.addEventListener("click", function () {
      setTimeout(function () {
        toggle(bar);
      }, 150);
    });

    setInterval(function () {
      toggle(bar);
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();